// extracted by mini-css-extract-plugin
export var divider = "_t4-0";
export var systemMessage = "_t4-1";